import { render, staticRenderFns } from "./olderList.vue?vue&type=template&id=ca50a45a&scoped=true&"
import script from "./olderList.vue?vue&type=script&lang=js&"
export * from "./olderList.vue?vue&type=script&lang=js&"
import style0 from "./olderList.vue?vue&type=style&index=0&id=ca50a45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca50a45a",
  null
  
)

export default component.exports